import Cashier from '@/views/cashier/index';
import RouteOrder from './RouteOrder';
import auth from '@/routers/middlewares/auth';
import cashier from '@/routers/middlewares/cashier';

export default [{
    path: '/cashier',
    name: 'index-cashier',
    component: Cashier,
    redirect: '/cashier/order',
    meta: {
        middleware: [auth, cashier]
    },
    children: [...RouteOrder]
}];